module.exports = __webpack_public_path__ + "static/img/logo1.79d5eaf.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/logo1.png
// module id = wkmb
// module chunks = 1